module.exports = {
  items: [
    "MRSpectroscopy",
    "GrayscaleSoftcopyPresentationState",
    "ColorSoftcopyPresentationState",
    "RawData",
  ],
  get_name(uid_arr) {
    var result = new Array();
    uid_arr.forEach(function (uid) {
      switch (uid) {
        case "1.2.840.10008.5.1.4.1.1.4.2":
          result.push("MRSpectroscopy");
          break;
        case "1.2.840.10008.5.1.4.1.1.11.1":
          result.push("GrayscaleSoftcopyPresentationState");
          break;
        case "1.2.840.10008.5.1.4.1.1.11.2":
          result.push("ColorSoftcopyPresentationState");
          break;
        case "1.2.840.10008.5.1.4.1.1.66":
          result.push("RawData");
          break;
        default:
          result.push("");
      }
    });
    return result;
  },
  get_uid(name_arr) {
    var result = new Array();
    name_arr.forEach(function (name) {
      switch (name) {
        case "MRSpectroscopy":
          result.push("1.2.840.10008.5.1.4.1.1.4.2");
          break;
        case "GrayscaleSoftcopyPresentationState":
          result.push("1.2.840.10008.5.1.4.1.1.11.1");
          break;
        case "ColorSoftcopyPresentationState":
          result.push("1.2.840.10008.5.1.4.1.1.11.2");
          break;
        case "RawData":
          result.push("1.2.840.10008.5.1.4.1.1.66");
          break;
        default:
          result.push("");
      }
    });
    return result;
  },
};